import { Container } from "@mui/material";
import { useParams } from "react-router-dom";
import articles from "./article";

import BlockchainArticle from "./content/BlockchainArticle";
import FairTransparentArticle from "./content/FairTransparentArticle";
import NftOwnershipArticle from "./content/NftOwnershipArticle";
import LotteryTicketProofArticle from "./content/LotteryTicketProofArticle";
import AutomaticWinnerSelectionArticle from "./content/AutomaticWinnerSelectionArticle";
import TieredPrizeArticle from "./content/TieredPrizeArticle";
import ReferralProgramArticle from "./content/ReferralProgramArticle";
import BiggerPayoutsArticle from "./content/BiggerPayoutsArticle";
import RealTimeUpdateArticle from "./content/RealTimeUpdateArticle";
import AutomaticPrizeDeliveryArticle from "./content/AutomaticPrizeDeliveryArticle";
import PublicBlockchainTrackingArticle from "./content/PublicBlockchainTrackingArticle";
import MobileWebAccessArticle from "./content/MobileWebAccessArticle";
import TrustlessSystemArticle from "./content/TrustlessSystemArticle";
import CreatorFriendlyArticle from "./content/CreatorFriendly-article";
import ZeroPaperworkArticle from "./content/ZeroPaperworkArticle";

const articleComponents = {
  "blockchain-lottery": <BlockchainArticle />,
  "fair-transparent": <FairTransparentArticle />,
  "nft-ownership": <NftOwnershipArticle />,
  "instant-proof-of-participation": <LotteryTicketProofArticle />,
  "automatic-winner-selection": <AutomaticWinnerSelectionArticle />,
  "tiered-prizes-more-wins": <TieredPrizeArticle />,
  "referral-program-benefits": <ReferralProgramArticle />,
  "low-fees-bigger-payouts": <BiggerPayoutsArticle />,
  "real-time-updates": <RealTimeUpdateArticle />,
  "automatic-prize-delivery": <AutomaticPrizeDeliveryArticle />,
  "public-blockchain-tracking": <PublicBlockchainTrackingArticle />,
  "mobile-web-access": <MobileWebAccessArticle />,
  "trustless-system": <TrustlessSystemArticle />,
  "creator-friendly": <CreatorFriendlyArticle />,
  "zero-paperwork": <ZeroPaperworkArticle />,
};

const ArticleDetail = () => {
  const { articleId } = useParams();
  const article = articles.find((a) => a.id === articleId);

  if (!article || !articleComponents[articleId]) {
    return <Container>Article not found</Container>;
  }

  return (
    <Container sx={{ py: 4, maxWidth: "md" }}>
      {articleComponents[articleId]}
    </Container>
  );
};

export default ArticleDetail;
